import * as BUNDLE_END_POINTS from "../constants/endpoints/bundle";
import axios from "../axios/axios";

export const getBundles = (params) => {
  return axios({
    url: BUNDLE_END_POINTS.GET_BUNDLES,
    method: "GET",
    params,
  });
};

export const getBundleDetails = (bundleId) => {
  return axios({
    url: BUNDLE_END_POINTS.GET_BUNDLE_DETAILS.replace(":bundleId", bundleId),
    method: "GET",
  });
};
